import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
//Components
import LayoutModal from "../../../LayoutModal";
import AddiotionInputs from "../AdditionInputs";
//icons
import { WarningCircle } from "@phosphor-icons/react";
//Inteface
import { Inputs } from "Interfaces/IPromotion";
import { IMethPay } from "Interfaces/IMethodPaym";
import { IUser } from "Interfaces/IUser";
interface ICreate {
  isOpenModalAcessory: boolean;
  setModalClose: () => void;

  idProducts: number[];
  type_product: string;
  urlProduct: {};

  setToastOpen: (value: boolean) => void;
  setToastData: (data: { status: number; message: string }) => void;
}

export default function CreatePromotion({
  isOpenModalAcessory,
  setModalClose,

  idProducts,
  type_product,
  urlProduct,
  setToastData,
  setToastOpen
}: ICreate) {

  const {
    register,
    control,
    reset,
    setValue,
    getValues,
    resetField,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const [paymentMethods, setPaymentMethods] = useState({
    cash: [],
    credit: { id: null, payment_method: '' },
    paymentCredit: { id: 0, payment_method: '' }
  });

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [users, setUsers] = useState<IUser[]>([]);
  const [visible, setVisible] = useState(false);
  const [messager, setMessager] = useState('Esta promoção será visível para todos os vendedores da loja e usuários com cargos superiores.');

  const typeUsers = (typeAdm: number, typeManag: number): string => {
    if (typeAdm === 1) return 'Administrador';
    if (typeAdm === 1 && typeManag === 1) return 'Administrador|Gerente';
    if (typeManag === 1) return 'Gerente';
    return 'Vendedor';
  };

  //Função para mostrar campo de VENDEDOR ESPECÍFICO
  const handleVisible = (auth: string) => {
    if (auth.toLocaleLowerCase() === 'loja') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }

  //função para mostrar mensagem de atenção
  const handleVisibleMessager = (value: number) => {
    if (!value) {
      setMessager('Esta promoção será visível para todos os vendedores da loja e usuários com cargos superiores.');
    } else {
      const user = users.filter((val) => val.id === value);
      console.log('users: ', user);
      setMessager(`Esta promoção será visível apenas para ${(user[0].first_name).toLocaleUpperCase() || '-'}. Outros vendedores da loja e usuários com cargos superiores não poderão ver esta promoção.`);
    }
  }

  const fetchData = async () => {
    try {
      const [responsePay, responseUser] = await Promise.all([
        axiosInstance.get("/payment-method"),
        axiosInstance.get("/user")
      ])

      const responseData = responsePay.data;
      const responseDataUser = responseUser.data.data;

      // Classificar métodos de pagamento
      const cash = responseData
        .filter((item: any) =>
          ['Dinheiro', 'Pix', 'Cartão de Débito'].includes(item.payment_method)
        ).map((payment: any) => ({
          ...payment,
          payment_method: payment.payment_method.replace('Cartão de Débito', 'Débito')
        }));

      const credit = responseData.find((item: any) =>
        item.payment_method === 'Cartão de Crédito'
      ) || null;

      const paymentCredit = responseData.find((item: any) =>
        item.payment_method === 'Crediário da Loja'
      ) || null;

      setUsers(responseDataUser);
      setPaymentMethods({
        cash,
        credit,
        paymentCredit
      });
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
  };

  useEffect(() => {
    if (isOpenModalAcessory) {
      fetchData();
    }
  }, [isOpenModalAcessory]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {

      const promotion_items = idProducts?.map((val) => {
        return {
          type: type_product,
          id: val
        }
      })

      const filtersUrl = Object.entries(urlProduct)
        .filter(([_, value]) => value !== "") //remover os filtros vazios
        .map(([key, value]) => ({
          type: key,
          name: String(value)
        }));

      const payload = {
        ...data,
        title: data.title.toLocaleUpperCase(),
        filters: filtersUrl,
        promotionItems: promotion_items || [],
      }

      const response = await apiRequest<Inputs>('promotion', 'POST', payload);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    setVisible(false);
    setMessager('Esta promoção será visível para todos os vendedores da loja e usuários com cargos superiores.');
    reset();
  }

  if (isOpenModalAcessory) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Promoção"
        subTitle="Preencha os dados da promoção do produto."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}>
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome da Promoção
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome da Promoção"
              type="text"
              {...register("title", { required: true })}
            />
            {errors.title && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Nível de Autorização
                <span>*</span>
              </S.Label>
              <S.Select
                {...register("auth", { required: true })}
                onChange={(e) => handleVisible(e.target.value)}
              >
                <option value="" disabled selected hidden>
                  Selecione
                </option>
                <option value="Administrador">
                  Administrador
                </option>
                <option value="Gerente">
                  Gerente
                </option>
                <option value="Loja">
                  Loja
                </option>
              </S.Select>
              {errors.auth && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            {
              visible &&
              <S.FormInput>
                <S.Label>
                  Vendedor Específico
                </S.Label>
                <S.Select
                  {...register("user_id")}
                  onChange={(e) => handleVisibleMessager(Number(e.target.value))}
                >
                  <option value="" selected>
                    Todos os Vendedores
                  </option>
                  {
                    users.map((value) => (
                      <option key={value.id} value={value.id}>
                        {`${value.first_name || '-'} (${typeUsers(value.is_admin, value.is_manager)})`}
                      </option>
                    ))
                  }
                </S.Select>
              </S.FormInput>
            }
          </S.SeparateDiv>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Período Inicial
                <span>*</span>
              </S.Label>
              <S.Input
                type="date"
                {...register("start", { required: true })}
              />
              {errors.start && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Período Final
                <span>*</span>
              </S.Label>
              <S.Input
                type="date"
                {...register("end", { required: true })}
              />
              {errors.end && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>
          </S.SeparateDiv>

          {
            visible &&
            <S.ContentInfor>
              <S.Text className="title">
                <WarningCircle size={12} /> Visibilidade da Promoção
              </S.Text>

              <S.Text className="subtitle">
                {messager}
              </S.Text>
            </S.ContentInfor>
          }

          <S.FeaturedSection>
            <S.Title>
              Desconto À vista (%)
              <span>*</span>
            </S.Title>
            {paymentMethods.cash.map((val: IMethPay, index: number) => (
              <S.FormInput key={val.id}>
                <S.ContentInput >
                  <S.LabelGray>{val.payment_method || '-'}</S.LabelGray>
                  <Controller
                    name={`cashPromotions.${index}.discount`}
                    rules={{ required: "Campo Obrigatório" }}
                    control={control}
                    render={({ field: { onChange, value, ref } }) => (
                      <NumericFormat
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={true}
                        placeholder="0,00 %"
                        suffix=" %"
                        value={value}
                        onValueChange={(values) => {
                          const discountValue = values.floatValue ?? 0;
                          setValue(`cashPromotions.${index}.payment_method_id`, val.id);
                          onChange(discountValue);
                        }}
                        getInputRef={ref}
                      />
                    )}
                  />
                </S.ContentInput>
                {errors.cashPromotions?.[index]?.discount && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

            ))}
          </S.FeaturedSection>

          <AddiotionInputs
            payment_method_id={paymentMethods.credit?.id || null}
            getValues={getValues}
            register={register}
            errors={errors}
            reset={reset}
            control={control}
            setValue={setValue}
            resetField={resetField} />

          <S.FormInput>
            <S.Label>
              Desconto no Crediário
              <span>*</span>
            </S.Label>
            <Controller
              name="paymentCreditPromotions"
              rules={{ required: "Campo Obrigatório" }}
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <NumericFormat
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  placeholder="0,00 %"
                  suffix=" %"
                  value={value?.[0]?.discount || ''}
                  onValueChange={(values) => {
                    const discountValue = values.floatValue ?? 0;

                    const newValue = [
                      {
                        discount: discountValue,
                        payment_method_id: paymentMethods.paymentCredit?.id || null
                      }
                    ];

                    onChange(newValue); // Atualiza com o objeto esperado
                  }}
                  getInputRef={ref}
                />
              )}
            />
            {errors.paymentCreditPromotions && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
